import { For, createSignal, createUniqueId } from "solid-js";

import { onPlayerLoad, usePlayer } from "~/components/PlayerContext";
import rootStyles from "~/components/Root.module.scss";
import Tooltip from "~/components/Tooltip";
import styles from "~/components/player/SourceSelect.module.scss";

interface SourceSelectProps {
  readonly alternate?: boolean;
}

export default function SourceSelect(props: SourceSelectProps) {
  const player = usePlayer();
  const id = createUniqueId();

  const tooltipContent = () => (
    <>
      Qualidade do streaming
      <br />
      <small>{player.allSources[player.currentSourceIndex]}</small>
    </>
  );

  return (
    <div
      classList={{
        [styles.wrapper]: true,
        [styles.alternate]: props.alternate,
      }}
    >
      <IconTablerMusicCog />
      <Tooltip
        content={tooltipContent()}
        as="select"
        id={id}
        // biome-ignore lint/a11y/useSemanticElements: defined on the "as" prop
        role="combobox"
        onChange={(event) => {
          window.jhplayer.currentSourceIndex = Number(event.target.value);
        }}
      >
        <For each={player.allSources}>
          {(source, index) => (
            <option
              value={index()}
              selected={index() === player.currentSourceIndex}
            >
              {source}
            </option>
          )}
        </For>
      </Tooltip>
      <label for={id} class={rootStyles["sr-only"]}>
        Qualidade do streaming
      </label>
    </div>
  );
}
